import Cookies from 'js-cookie';

// eslint-disable-next-line import/prefer-default-export
export function isAdacCustomer() {
  return Cookies.get('ref') === 'adac';
}
